module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "clas": "row col-xs-12"
    }
  }, [_c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "col-xs-12 top-bar pv3 middle-xs"
  }, [_c('div', {
    staticClass: "tl"
  }, [_c('pl-button', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "back-btn truncate-text pl-white-font"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tc admin-portal-title"
  }, [_vm._v("\n        System - Wide Data\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row scroll-container"
  }, [_c('nav', {
    staticClass: "col-xs-12 col-md-3 col-lg-2 pt4"
  }, [_c('ul', {
    staticClass: "menu-sidenav"
  }, _vm._l((_vm.displayable_tabs), function(selected_tab, key) {
    return _c('li', {
      key: key,
      staticClass: "row middle-xs h-100",
      class: {
        'selected-tab': _vm.is_selected_tab(selected_tab.routeName)
      },
      staticStyle: {
        "vertical-align": "middle",
        "margin-top": "5px"
      },
      on: {
        "click": function($event) {
          selected_tab.href ? _vm.goToExternalLink(selected_tab.href) : _vm.goToTab(selected_tab.routeName)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "18px",
        "margin-right": "10px"
      },
      attrs: {
        "src": ("/static/" + (selected_tab.icon)),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(selected_tab.title) + "\n          ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9 col-lg-10"
  }, [_c('transition', [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-41d10863!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalParlay/adminPortalParlay.vue
// module id = 2193
// module chunks = 61